export default __webpack_public_path__ + "static/five-logos-620df8af5114d3fdee02c641a1c0dd88.png";